<app-page-wait *ngIf="loading"></app-page-wait>

<div *ngIf="simulationEnabled" class="simulation-controls d-flex gap-2">
  <button mat-stroked-button type="button" (click)="simulateReset()">Reset</button>
  <button mat-stroked-button type="button" (click)="simulatePrevious()">Previous</button>
  <button mat-stroked-button type="button" (click)="simulateNext()">Next</button>
</div>

<app-animation-page
  *ngIf="(flowStep$ | async) !== TokenizationFlowStep.IDLE; else cardWrapper"
></app-animation-page>

<ng-template #cardWrapper>
  <div
    class="app-container d-flex flex-column"
    [class.vh-100]="!openIframeConsumerAuthentication"
  >
    <app-card-wrapper
      *ngIf="!openIframeConsumerAuthentication"
      [isLoading]="loading"
      (formSubmitted)="tokenizationProcess($event)"
      class="mt-2 flex-grow-1"
    >
    </app-card-wrapper>
  </div>
</ng-template>

<!-- Data Collection iframe: 3DS pre auth  -->
<iframe 
  id="cardinal_collection_iframe" 
  name="collectionIframe" 
  height="1" 
  width="1" 
  style="display: none;"

  sandbox="allow-scripts allow-forms allow-same-origin"
  referrerpolicy="no-referrer"
  allow="geolocation 'none'; microphone 'none'; camera 'none'; 
    autoplay 'none'; encrypted-media 'none'; payment 'none'"
>
</iframe>
<form id="cardinal_collection_form" method="POST" target="collectionIframe">
  <input id="cardinal_collection_form_input" type="hidden" name="JWT" value="">
</form>

<!-- Consumer Authentication iframe: 3DS auth -->
<iframe 
  *ngIf="openIframeConsumerAuthentication" 
  id="step_up_iframe"
  name="stepUpIframe"
  sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
  referrerpolicy="no-referrer"
  allow="geolocation 'none'; camera 'none'; autoplay 'none'; 
    encrypted-media 'none'; payment 'none'"
>
</iframe>
<form id="step_up_form" name="stepup" method="POST" target="stepUpIframe">
  <input id="step_up_form_jwt_input" type="hidden" name="JWT" value="">
</form>
